import { render, staticRenderFns } from "./VideoWithCardsBlock.vue?vue&type=template&id=f4bac7c2"
import script from "./VideoWithCardsBlock.vue?vue&type=script&lang=js"
export * from "./VideoWithCardsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports